<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "userFlag":"xxxx"
           },
            responseCode: {"data":{
                "phone":"18200946810",
                "carList":[{"carCode":"粤TEST01","authLevel":0}]
            },"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "根据用户标识表示获取用户基础信息（智慧停车发现模块所带标识）",
                t_url: this.commonUrls.test+"getYdtUserBaseInfoByFlag",
                p_url: this.commonUrls.prod+"getYdtUserBaseInfoByFlag",
                precondition: "无",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userFlag', info2: '是', info3: 'String', info4: '用户标识' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userId', info2: '是', info3: 'int', info4: '智慧停车用户唯一ID' },
                        { info1: 'phone', info2: '是', info3: 'int', info4: '智慧停车用户手机号' },
                        { info1: 'carList', info2: '是', info3: 'JSONArray', info4: '车辆列表' },
                        ]
                    },
                    {
                        titleName: 'carList',
                        tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                        td: [
                            { info1: 'carCode', info2: '是', info3: 'String', info4: '车牌' },
                            { info1: 'authLevel', info2: '是', info3: 'int', info4: '认证级别：0未认证，1缴费认证，2行驶证认证，3实名认证' },
                            ]
                    }
                ]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getYdtUserBaseInfoByFlag.vue